import Vue from "vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ja";
import i18nLocale from "@/helpers/locale";
// import Http from "@/helpers/service/http";
import axios from "axios";
import _ from "lodash";
import App from "./App.vue";
import ComingSoon from "@/components/common/ComingSoon";
import * as filters from "@/utils/filters";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import "./themes/default.less";
import "@/assets/iconfont/iconfont.css";
import "default-passive-events";
import directives from "@/utils/directive";
import util from "@/utils/utils";
import { isValidDate, safeFormateDate, safeJoin } from '@/utils/common';
import richText from "@/utils/richText";
import VCalendar from "v-calendar";
import Print from "vue-print-nb";

import { clearData } from '@/utils/version'
// import "@/assets/style/customComponents.less"; // Has merged to common.less file

// 版本不对应 删除缓存数据
clearData()

Vue.use(ElementUI, { locale });
Vue.use(directives);
Vue.use(VCalendar, {
  componentPrefix: "vc",
});
Vue.use(Print);

Vue.component("coming-soon", ComingSoon);

Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$locale", { value: i18nLocale });
// Object.defineProperty(Vue.prototype, "$Http", { value: Http });
Object.defineProperty(Vue.prototype, "$axios", { value: axios });
Object.defineProperty(Vue.prototype, "$_", { value: _ });
Object.defineProperty(Vue.prototype, "$util", { value: util });
Object.defineProperty(Vue.prototype, "$richText", { value: richText });
// 全局函数
Object.defineProperty(Vue.prototype, "$isValidDate", { value: isValidDate });
Object.defineProperty(Vue.prototype, "$safeJoin", { value: safeJoin });
Object.defineProperty(Vue.prototype, "$safeFormatDate", { value: safeFormateDate });

Vue.config.productionTip = false;
Vue.config.devtools = true;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
